import React, { useState } from 'react';
import { block } from 'bem-cn';

import './pion-content-url.scss';
import { PionType, ImmutableMapItem } from '../../../type';

const b = block('pion-content-url');

type PionUrlContentPropsType = {
  pion: Pick<
    PionType,
    keyof ImmutableMapItem | 'id' | 'type' | 'url' | 'urlTitle' | 'preview'
  >;
};

const PionUrlContent = ({ pion }: PionUrlContentPropsType) => {
  const [imageLoadError, setImageLoadError] = useState(false);

  return (
    <div className={b()}>
      <div
        className={b('icon', {
          'no-image':
            !(pion.get('preview') || pion.get('favicon')) || imageLoadError,
        })}
      >
        {(pion.get('preview') || pion.get('favicon')) && !imageLoadError && (
          <img
            data-testid='preview'
            src={pion.get('preview') || pion.get('favicon')}
            alt={pion.get('urlTitle')}
            onError={() => {
              setImageLoadError(true);
            }}
          />
        )}
      </div>
      <div className={b('info')}>
        <div data-testid='title' className={b('title')}>
          <span>{pion.get('urlTitle')}</span>
        </div>
        <div data-testid='url' className={b('url')}>
          {pion.get('url')}
        </div>
      </div>
    </div>
  );
};

export default PionUrlContent;
